import styled from "styled-components";

export const Wrapper = styled.div`
  margin-bottom: 0;
  position: relative;
`;
